<script lang="ts">
	import domain from '$lib/stores/DomainStore';
	import Hero from '$lib/components/Home/Hero.svelte';
	import Instructions from '$lib/components/Home/Instructions.svelte';
	import Banks from '$lib/components/Global/Banks.svelte';
	import Choices from '$lib/components/Home/Choices.svelte';
	import Advantages from '$lib/components/Home/Advantages.svelte';
	import Help from '$lib/components/Global/Help.svelte';
	import Simulation from '$lib/components/Home/Simulation.svelte';
	import __ from '$lib/stores/TranslationStore';
	import NewsletterForm from '$lib/components/Global/Newsletter/NewsletterForm.svelte';
	import { onMount } from 'svelte';

	onMount(() => {
		// workaround for anchor problem
		const id = window.location.hash.replace(/^#/, '');
		const element = id && document.getElementById(id);
		if (id && element) {
			element.scrollIntoView();
		}
	});
</script>

<svelte:head>
	<title>{$__('Poupe tempo e dinheiro no seu crédito e seguro')}</title>
	<meta
		name="description"
		content={$__(
			'Poupe tempo e dinheiro com o Poupança no Minuto! Somos compostos por uma equipa experiente de intermediários de crédito e mediadores de seguros.'
		)}
	/>
	<meta property="og:image" content="/og/open-graph-home.png" />
</svelte:head>

<Hero />
<Choices />
<Banks />
<Instructions />
<Advantages />
<NewsletterForm />
<Help />
<Simulation />
